module.exports = __webpack_public_path__ + "img/icon_piyao_upload.d05bf850.png";